import React from "react";
import PropTypes from "prop-types";
import withSnack from "./withSnack";
import { createPortal } from "react-dom";
import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid
} from "@material-ui/core/";
import { QRCode } from "react-qr-svg";
import UserStore from "../stores/UserStore";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton/IconButton'

const isTFAEnabled = () => {
  return UserStore.getLocal("tfa") === "true";
};

class TFAVerify extends React.Component {
  state = {
    code: "",
    wrong: false
  };

  componentWillUnmount() {
    if (this.defaultNode) {
      document.body.removeChild(this.defaultNode);
    }
    this.defaultNode = null;
  }
  check_code = e => {
    e.preventDefault();
    const { code } = this.state;
    UserStore.valid_code(code).then(r => {
      if (r.data.success === true) {
        this.onClose();
        this.props.onContinue();
        this.props.snack("Éxito código válido", 'success');
      } else {
        this.setState({ wrong: true });
        this.props.snack("Error código inválido", 'warning');
      }
    });
  };

  onCodeChange = e => {
    this.setState({ code: e.target.value });
  };

  onClose = () => {
    this.setState({ code: "", qr: null });
    this.props.onClose();
  };

  _render() {
    const { open, can_create } = this.props;
    const { code, wrong } = this.state;
    if (UserStore.isTFA() === false) return null;

    let closeButton = (
      <IconButton onClick={this.onClose} className="close_fix_button" >
        <CloseIcon/>
      </IconButton>
    );

    if(can_create === 'true') {
      closeButton = null;
    }

    return (
      <Dialog aria-labelledby="TFAVerify" open={open} maxWidth="sm" >
        <DialogTitle style={{textAlign: "center"}}>Autenticación de dos pasos
          {closeButton}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={8} justify="center" alignItems="center">
            <Grid item sm={8}>
              Actualmente, la verificación de dos pasos está activada, para
              continuar introduzca el código que se muestra en la aplicación de
              Autenticador de Google.
            </Grid>
            <Grid item sm={4}>
              <form onSubmit={this.check_code}>
                <Grid
                  container
                  spacing={8}
                  alignItems="center"
                  justify="center"
                >
                  <Grid item sm={12}>
                    <TextField
                      className="inputCenter"
                      autoFocus
                      label="Ingrese el código"
                      variant="outlined"
                      type="text"
                      value={code}
                      error={wrong}
                      onChange={this.onCodeChange}
                      inputProps={{
                        maxLength: 6
                      }}
                    />
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions  >
          <Button variant="contained" onClick={this.check_code}>
            Verificar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    if (!this.defaultNode) {
      this.defaultNode = document.createElement("div");
      document.body.appendChild(this.defaultNode);
    }
    return createPortal(this._render(), this.defaultNode);
  }
}
TFAVerify = withSnack(TFAVerify);
TFAVerify.propTypes = {
  onClose: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

class TFASetup extends React.Component {
  state = {
    qr: null,
    code: "",
    wrong: false,
    tfa: false
  };

  constructor(props) {
    super(props);
    this.check_code = this.check_code.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.state.tfa !== UserStore.isTFA())
      this.setState({ tfa: UserStore.isTFA(), code: "" });
    //retrieve new qr code only if the modal is open
    if (this.props.open === true && this.props.open !== prevProps.open) {
      UserStore.totp_qr().then(r => {
        this.setState({ qr: r.data.qr });
      });
    }
  }

  onClose = () => {
    this.setState({ code: "", qr: null });
    this.props.onClose();
  };

  check_code = e => {
    e.preventDefault();
    const { tfa, code } = this.state;
    UserStore.toggle_tfa(code, tfa).then(r => {
      const { success } = r.data;
      let ns = {};
      if (success === true) {
        if (tfa) this.props.snack("Desactivación exitosa", 'success');
        else this.props.snack("Activación exitosa", 'success');
          if(this.props.setupLogin === true){
            this.props.onContinue();
          }
        UserStore.saveLocal("tfa", !tfa);
        this.props.onClose();
        ns = { wrong: false, tfa: !tfa, code: "" };
      } else {
        this.props.snack("Error código inválido", 'warning');
        ns = { wrong: true, code: "" };
      }
      this.setState(ns);
    });
  };

  onCodeChange = e => {
    this.setState({ code: e.target.value });
  };

  render() {
    const { open, can_create } = this.props;
    const { qr, code, wrong, tfa } = this.state;
    let closeButton = (
      <IconButton onClick={this.onClose} className="close_fix_button" >
        <CloseIcon/>
      </IconButton>
    );

    if(can_create === 'true') {
      closeButton = null;
    }
    return (
      <Dialog aria-labelledby="TFASetup" open={open} >
        <DialogTitle style={{textAlign: "center"}}>Autenticación de dos pasos
          {closeButton}
        </DialogTitle>
        <DialogContent style={{paddingBottom: "10px"}}>
          {tfa === true ? (
            <TFADisable
              code={code}
              wrong={wrong}
              onCodeChange={this.onCodeChange}
              check_code={this.check_code}
            />
          ) : (
            <TFAEnable
              qr={qr}
              code={code}
              wrong={wrong}
              onCodeChange={this.onCodeChange}
              check_code={this.check_code}
            />
          )}
        </DialogContent>
        <DialogActions style={{justifyContent:"center", marginBottom:"1.5em" }} >
          <Button variant="contained" color="primary" onClick={this.check_code}>
          {tfa? 'Desvincular' : 'Verificar' }
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
TFASetup = withSnack(TFASetup);
TFASetup.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

const TFADisable = props => {
  const { code, wrong, onCodeChange, check_code } = props;
  return (
    <Grid container spacing={8} justify="center" alignItems="center">
      <Grid item sm={12}>
        Actualmente, la verificación de dos pasos está activada, si desea
        desactivarla introduzca el código que se muestra en la aplicación de
        Autenticador de Google.
      </Grid>
      <Grid item sm={6}>
        <form onSubmit={check_code}>
          <Grid container spacing={8} alignItems="center" justify="center">
            <Grid item sm={8}>
              <TextField
                className="inputCenter"
                variant="outlined"
                type="text"
                value={code}
                error={wrong}
                onChange={onCodeChange}
                inputProps={{
                  maxLength: 6,
                }}
              />
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

const TFAEnable = props => {
  const { qr, code, wrong, onCodeChange, check_code } = props;
  return (
    <Grid container spacing={8} justify="center" alignItems="center">
      <Grid item sm={12}>
        La verificación de dos pasos agrega una capa adicional de protección a
        su cuenta.</Grid>
      <Grid item sm={12} style={{ marginTop: "1em"}}>
        Para habilitar la autenticación de dos pasos instale en su dispositivo la aplicación de
        <strong> Google Authenticator</strong>. Una vez instalado, seleccione la opción "Escanear
        código" y escanee con su teléfono el siguiente código QR:
      </Grid>

      <Grid item sm={12} style={{ marginTop: "1em"}}>
        <Grid container spacing={8} alignItems="center" justify="center">

          {qr === null ? null : (

            <QRCode style={{ width: 200 }} value={qr} level="L" />

          )}

        </Grid>
      </Grid>
      <Grid item sm={6}>
        <form onSubmit={check_code}>
          <Grid container spacing={8} alignItems="center" justify="center">
            <Grid style={{marginTop: "1em", marginBottom: ".5em"}}>Ingrese el código de autenticación</Grid>
            <Grid item sm={6}>
              <TextField
                className="inputCenter"
                variant="outlined"
                type="text"
                value={code}
                error={wrong}
                onChange={onCodeChange}
                inputProps={{
                  maxLength: 6
                }}
              />
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};
export { TFAVerify, TFASetup, isTFAEnabled };



// WEBPACK FOOTER //
// ./src/components/2FA.js